
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"60","height":"60"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M7.1 14.32v34.49a9.17 9.17 0 009 9.32h27.84a9.17 9.17 0 009-9.32V14.32z","fill":"none","stroke":"#241f21","stroke-miterlimit":"10","stroke-width":"2"}}),_c('path',{attrs:{"d":"M51.9 14.32h6.52s1 8.82-4 8.82h-1.3M8.1 14.32H1.58s-1 8.82 4 8.82h1.5","fill":"none","stroke":"#241f21","stroke-miterlimit":"10","stroke-width":"2"}}),_c('path',{attrs:{"d":"M52.8 14.15a37.69 37.69 0 00-22.69-7.8 37.73 37.73 0 00-22.91 8","fill":"none","stroke":"#241f21","stroke-miterlimit":"10","stroke-width":"2"}}),_c('path',{attrs:{"fill":"none","stroke":"#241f21","stroke-miterlimit":"10","stroke-width":"2","d":"M25.67 6.85V1.87h8.66v4.98M31.65 52.52h9.64a6.13 6.13 0 006-6.22V36.23"}})])
          )
        }
      }
    